import { useCallback, useRef, useMemo } from 'react';

export default function useAddRemoteController(sendEvent) {
    const addRemoteCallbacks = useRef({});
    const registerNotification = useCallback((callbackId, callback) => {
        addRemoteCallbacks.current[callbackId] = callback;
    }, []);
    const unregisterNotification = useCallback((callbackId) => {
        if (callbackId in addRemoteCallbacks.current)
            delete addRemoteCallbacks.current[callbackId];
    }, []);

    const onAddRemote = useCallback((message) => {
        switch (message.msg.sub_event) {
            case "error":
            case "get_sub_device_types":
            case "get_remote_brands":
            case "get_remote_indices":
            case "virtual_remote_joined_notification":
                for (const id in addRemoteCallbacks.current) {
                    // if (addRemoteCallbacks.current.hasOwnProperty(id)) {
                    if (Object.prototype.hasOwnProperty.call(addRemoteCallbacks.current, id)) {
                        const callback = addRemoteCallbacks.current[id];
                        callback(message.msg);
                    }
                }
                break;
            default:
                break;
        }
    }, []);

    const getSubTypes = useCallback((mac) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "get_sub_device_types",
            "device_mac": mac
        });
    }, [sendEvent]);

    const getBrands = useCallback((mac, subDeviceType) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "get_remote_brands",
            "device_mac": mac,
            "sub_device_type": subDeviceType
        });
    }, [sendEvent]);

    const getIndices = useCallback((mac, subDeviceType, brandId) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "get_remote_indices",
            "device_mac": mac,
            "sub_device_type": subDeviceType,
            "brand_id": brandId
        });
    }, [sendEvent]);

    const sendTestCommand = useCallback((mac, subDeviceType, brandId, index, func) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "test_command",
            "device_mac": mac,
            "sub_device_type": subDeviceType,
            "brand_id": brandId,
            "index": index,
            "function": func,
        });
    }, [sendEvent]);

    const discardTempRemote = useCallback((mac, subDeviceType) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "discard_temp_remote",
            "device_mac": mac,
            "sub_device_type": subDeviceType,
            // "brand_id": brandId,
            // "index": index
        });
    }, [sendEvent]);

    const join = useCallback((mac, subDeviceType, brandId, index) => {
        sendEvent('add_virtual_remote', {
            "sub_event": "join_virtual_remote",
            "device_mac": mac,
            "sub_device_type": subDeviceType,
            "brand_id": brandId,
            "index": index
        });
    }, [sendEvent]);

    const addRemoteController = useMemo(() => {
        return {
            registerNotification,
            unregisterNotification,

            getSubTypes,
            getBrands,
            getIndices,

            sendTestCommand,
            discardTempRemote,
            join,
        }
    }, [registerNotification, unregisterNotification, 
        getSubTypes, getBrands, getIndices, 
        sendTestCommand, discardTempRemote, join]);
    return [onAddRemote, addRemoteController];
}